import PhoneIconMUI from '@mui/icons-material/Phone';

export const PhoneIconContained = PhoneIconMUI;
